import SessionHistory from "@/components/dashboard/SessionHistory";

const History = () => {
  return (
    <div className="container mx-auto px-6 py-8 max-w-7xl">
      <div className="space-y-6">
        <div>
          <h1 className="text-4xl font-bold bg-gradient-hero bg-clip-text text-transparent">
            Session History
          </h1>
          <p className="text-muted-foreground mt-2">
            View all your past streaming sessions and usage
          </p>
        </div>

        <SessionHistory />
      </div>
    </div>
  );
};

export default History;
